module.exports = __webpack_public_path__ + "img/CM-EC-24-Acura-Established.e4afd42f.jpg";